import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Vuex from 'vuex'

Vue.use(Router);
Vue.use(Vuex)

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/list",
      name: "home",
      component: Home,
      meta: { title: 'ちょい読み 登録一覧', desc: 'ちょい読みサービスの登録コンテンツ一覧です。' },
    },
    {
      path: "/",
      name: "book",
      meta: { title: 'ちょい読み' },
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "book" */ "./views/Book.vue")
    },
    {
      path: '*', redirect: '/'
    },
  ],
});
